import React from "react";
import { BlogHeader } from "../../components/BlogHeader";
import { Developing } from "../../blocks/developing";

export const TopicPage = () => {
  return (
    <div
      style={{
        paddingTop: 60,
      }}
    >
      <BlogHeader />
      <Developing />
    </div>
  );
};
